import { Component, Inject, Input, Optional } from '@angular/core';
import { ControlContainer, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { BaseFormDirective } from '../directives/base-form.directive';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import moment, { Moment } from 'moment';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DynamicDateFormat } from '../../utils/dynamic-date-format';
import { KeyValuePipe, NgClass, NgForOf, NgIf, NgStyle } from '@angular/common';
import { TsDateMaskDirective } from '../directives';

@Component({
  selector: 'ts-datepicker',
  standalone: true,
  imports: [
    MatInputModule,
    MatIconModule,
    MatMomentDateModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    NgClass,
    NgForOf,
    NgIf,
    KeyValuePipe,
    TsDateMaskDirective,
    NgStyle,
  ],
  templateUrl: './ts-datepicker.component.html',
  styleUrl: './ts-datepicker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TsDatepickerComponent,
      multi: true,
    },
    { provide: MAT_DATE_FORMATS, useClass: DynamicDateFormat },
  ],
})
export class TsDatepickerComponent extends BaseFormDirective {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() hint: string;
  @Input() min: string; // Date in ISO format
  @Input() max: string; // Date in ISO format
  @Input() mode: 'month' | 'year' | 'multi-year' = 'month';
  @Input() errorMessages: { [validationErrorKey: string]: string } = {
    matDatepickerParse: 'Please enter a valid date.',
  };

  constructor(
    @Optional() protected controlContainer: ControlContainer,
    @Inject(MAT_DATE_FORMATS) protected dateFormat: DynamicDateFormat,
  ) {
    super(controlContainer);
  }

  ngOnInit() {
    this.dateFormat.mode = this.mode;
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    if (this.mode === 'multi-year') {
      const ctrlValue = this.control?.value || moment();

      ctrlValue.month(normalizedMonthAndYear.month());
      ctrlValue.year(normalizedMonthAndYear.year());

      this.control.setValue(ctrlValue);
      this.control.markAsDirty();
      this.control.updateValueAndValidity();
      this.control.markAsTouched();

      datepicker.close();
    }
  }
}
